import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate ,Outlet } from 'react-router-dom';
import { store } from './store';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';

// Layout components
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';

// Auth components
import Login from './components/auth/Login';
import Register from './components/auth/Register';

// User components
import MealSuggestions from './components/user/MealSuggestions';
import AIMealSuggestions from './components/user/AIMealSuggestions';
import MealLog from './components/user/MealLog';
import Favorites from './components/user/Favorites';
import MealsForYou from './components/user/MealsForYou';
import MealPlanner from './components/user/MealPlanner';

// Admin components
import AdminDashboard from './components/admin/Dashboard';
import ManagePreferences from './components/admin/ManagePreferences';
import ManageMeals from './components/admin/ManageMeals';
import AdminNavigation from './components/admin/AdminNavigation';
import AdminAccessPanel from './components/admin/AdminAccessPanel';
import TestDatabaseStore from './components/admin/TestDatabaseStore';
import NotificationPanel from './components/admin/NotificationPanel';
// import ProtectedRoute from './ProtectedRoute';
import {
  ProtectedRoute,
  ProtectedUserRoute,
  ProtectedAdminRoute
} from './ProtectedRoute';

//Policy Files
import PrivacyPolicy from './components/policyFiles/privacypolicy';
import SupportPage from './components/policyFiles/support';
import { ConstructionOutlined, ContactSupportOutlined } from '@mui/icons-material';





function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <BrowserRouter>
      
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<SupportPage />} />

          {/* Protected User Routes */}
          <Route
            path="/"
            element={
              <ProtectedUserRoute>
                <UserLayout />
              </ProtectedUserRoute>
            }
          >
            <Route index element={<MealSuggestions />} />
            <Route path="ai-suggestions" element={<AIMealSuggestions />} />
            <Route path="meal-log" element={<MealLog />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="meals-for-you" element={<MealsForYou />} />
            <Route path="meal-planner" element={<MealPlanner />} />
          </Route>

          {/* Protected Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="navigation" element={<AdminNavigation />} />
            <Route path="preferences" element={<ManagePreferences />} />
            <Route path="meals" element={<ManageMeals />} />
            <Route path="notifications" element={<NotificationPanel />} />
          </Route>

          {/* Direct Admin Access Panel */}
          <Route
            path="/admin-panel"
            element={
              <ProtectedAdminRoute>
                <AdminAccessPanel />
              </ProtectedAdminRoute>
            }
          />

          {/* DB Test Route (also protected?) */}
          <Route
            path="/db-test"
            element={
              <ProtectedAdminRoute>
                <React.Suspense fallback={<div>Loading...</div>}>
                  <TestDatabaseStore />
                </React.Suspense>
              </ProtectedAdminRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
